// Versão: 1.00
// Data..: 2026-10-03
// Guard de rota por papel (role). Protege rotas que só certos papéis podem acessar.
// Sem usuário autenticado -> portal público; papel sem permissão -> raiz (ou /timeclock
// quando o papel for Contabilidade, que só enxerga o Ponto).

import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { UserRole } from '@makweb/shared';
import { useAuth } from '../context/AuthContext.js';

export function RequireRole({ roles, children }: { roles: UserRole[]; children: ReactNode }) {
  const { user } = useAuth();
  // Não autenticado: manda para o portal público.
  if (!user) return <Navigate to="/portal" replace />;
  // Papel sem permissão para esta rota: contabilidade cai no Ponto; demais na raiz.
  if (!roles.includes(user.role)) {
    const fallback = user.role === UserRole.ACCOUNTING ? '/timeclock' : '/';
    return <Navigate to={fallback} replace />;
  }
  return <>{children}</>;
}
